import { render, staticRenderFns } from "./ChunkedVideoUploader.vue?vue&type=template&id=1f97b2f4&scoped=true&"
import script from "./ChunkedVideoUploader.vue?vue&type=script&lang=js&"
export * from "./ChunkedVideoUploader.vue?vue&type=script&lang=js&"
import style0 from "./ChunkedVideoUploader.vue?vue&type=style&index=0&id=1f97b2f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f97b2f4",
  null
  
)

export default component.exports